import React from 'react';
import { AuthProvider } from './AuthContext';
import { UIProvider } from './UIContext';
import { ConfigProvider } from './ConfigContext';
import { VoucherProvider } from './VoucherContext';
import { StatProvider } from './StatContext';
import { MobileMoneyProvider } from './MobileMoneyContext';
import { CustomerProvider } from './CustomerContext';
import { NetworkProvider } from './NetworkContext';
import { SalesProvider } from './SalesContext';
import { MySaleProvider } from './MySaleContext';

const SuperStore = ({children}) => {
    return (
        <AuthProvider>
            <UIProvider>
                <ConfigProvider>
                    <VoucherProvider>
                        <StatProvider>
                            <MobileMoneyProvider>
                                <CustomerProvider>
                                    <NetworkProvider>
                                        <SalesProvider>
                                            <MySaleProvider>
                                            {children}
                                            </MySaleProvider>
                                        </SalesProvider>
                                    </NetworkProvider>
                                </CustomerProvider>
                            </MobileMoneyProvider>
                        </StatProvider>
                    </VoucherProvider>
                </ConfigProvider>
            </UIProvider>
        </AuthProvider>
    );
};

export default SuperStore;